export enum QuotePriceType {
  PREVIOUS_CLOSE = 'PREVIOUS_CLOSE',
  STRIKE_PRICE = 'STRIKE_PRICE'
}
